require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-amanda-o-shannessy-angela-stugren.json") })
        }
      }, "path---blog-author-amanda-o-shannessy-angela-stugren");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-amanda-o-shannessy-angela-stugren!./.cache/json/blog-author-amanda-o-shannessy-angela-stugren.json
// module id = 605
// module chunks = 231608221292675